import { AtlasChatbotProps } from "@amzn/atlas-chat-react-library";

/** Messages with duplicates removed by messageId, keeping the most recent copy. */
export const dedupeMessagesById = (
  messages: AtlasChatbotProps.ConversationMessage[],
): AtlasChatbotProps.ConversationMessage[] => {
  const byId = new Map<string, AtlasChatbotProps.ConversationMessage>();
  messages.forEach((message, index) => {
    byId.set(message.messageId ?? `no-id-${index}`, message);
  });
  return [...byId.values()];
};
